<style lang="scss" src="@/assets/scss/index.scss"></style>
<template>
    <div id="app">
        <app-background :progress="progress" />
        <app-header @about-click="showAbout" />
        <transition v-if="routeLoaded" :name="routeTransition" mode="out-in">
            <router-view id="main" />
        </transition>
        <main v-else id="main"></main>
        <app-footer />
        <about v-if="aboutData" :active="aboutActive" :data="aboutData" @close="hideAbout" />
        <crowdsource-box @close="setCrowdsourceActive(false)" :active="crowdsourceActive" />
    </div>
</template>
<script>
import AppHeader from '@/components/AppHeader'
import AppBackground from '@/components/AppBackground'
import AppFooter from '@/components/AppFooter'
import About from '@/components/About'
import CrowdsourceBox from '@/components/CrowdsourceBox'

import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    name: 'App',
    data: () => ({
        routeLoaded: false,
        routeTransition: 'slide-up',
    }),
    computed: {
        ...mapState([
            'progress',
            'aboutActive',
            'aboutData',
            'crowdsourceActive',
        ]),
    },
    watch: {
        '$route'(to, from) {
            if (to.matched.length) {
                this.routeLoaded = true
            }
            if (typeof to.query.about !== 'undefined' && !this.aboutActive) {
                this.showAbout()
            } else if (typeof to.query.about === 'undefined' && this.aboutActive) {
                this.hideAbout()
            }
            if (typeof to.meta.progress !== 'undefined') {
                this.setProgress(to.meta.progress)
            }

            const toDepth = to.path.split('/').filter(segment => Boolean(segment)).length
            const fromDepth = from.path.split('/').filter(segment => Boolean(segment)).length
            this.routeTransition = toDepth < fromDepth ? 'slide-down' : 'slide-up'
        },
    },
    methods: {
        showAbout() {
            this.setAboutActive(true)
            document.querySelector('body').classList.add('noscroll')
            this.$router.push({...this.$route, query: {...this.$route.query, about: null}})
        },
        hideAbout() {
            this.setAboutActive(false)
            document.querySelector('body').classList.remove('noscroll')
            this.$router.push({...this.$route, query: {...this.$route.query, about: undefined}})
        },
        ...mapActions([
            'getAboutData',
        ]),
        ...mapMutations([
            'setProgress',
            'setAboutActive',
            'setCrowdsourceActive',
        ]),
    },
    mounted() {
        this.getAboutData()
    },
    components: {
        AppHeader,
        AppBackground,
        AppFooter,
        About,
        CrowdsourceBox,
    },
}
</script>
